export default "__VITE_ASSET__b0cdd565__"